const NextI18Next = require('next-i18next').default

/**
 * Synchronize language with legacy VietnamWorks website
 */
const legacyLangDetector = {
	name: 'legacyLangDetector',
	lookup: (req, res, options) => {
		let found = 'vi';
		const { lang } = req.cookies;

		if (lang == 1) {
			found = 'vi';
		} else if (lang == 2) {
			found = 'en';
		}
		if (req.url.indexOf('/job-search') >= 0) {
			found = 'en';
		} else if (req.url.indexOf('/tim-viec-lam') >= 0) {
			found = 'vi';
		}
		if (req.url.indexOf('/featured-jobs') >= 0) {
			found = 'en';
		} else if (req.url.indexOf('/viec-lam-tot-nhat') >= 0) {
			found = 'vi';
		}
		if (req.url.indexOf('/recommended-jobs') >= 0) {
			found = 'en';
		} else if (req.url.indexOf('/viec-lam-goi-y') >= 0) {
			found = 'vi';
		}
		if (req.url.indexOf('/numerology') >= 0) {
			found = 'en';
		} else if (req.url.indexOf('/nhan-so-hoc') >= 0) {
			found = 'vi';
		}
		if (req.url.indexOf('/ruling-number') >= 0) {
			found = 'en';
		} else if (req.url.indexOf('/so-chu-dao') >= 0) {
			found = 'vi';
		}
		if (req.url.indexOf('/event') >= 0) {
			found = 'en';
		} else if (req.url.indexOf('/su-kien') >= 0) {
			found = 'vi';
		}

		return found;
	}
};

let config = {
	defaultLanguage: 'vi', // vi
	otherLanguages: ['en'], // en
	fallbackLng: 'en',
	defaultNS: 'home',
	browserLanguageDetection: false, // must set to false to make legacyLangDetector works
	detection: {
		order: ['querystring', 'legacyLangDetector'],
		lookupQuerystring: "lang", // url with ?lang=vi or ?lang=en will be set to correct language        
	},
	customDetectors: [legacyLangDetector]
}

if (process.browser) {
	config.backend = {
		loadPath: `${process.env.APP_ASSET_URL}/static/locales/{{lng}}/{{ns}}.json`,
	}
}

module.exports = new NextI18Next(config)
